export const ANALYTICS_IDS_KEY = 'analytics-ids'
export const MEMBER_EXPERIMENT_FIRST_SESSION_ID_KEY = 'member-experiment-first-session-id'
export const SESSION_EVENT_SENT_ID_KEY = 'session-event-sent-id'
export const LAST_VISIT_TIMESTAMP_KEY = 'last-visit-timestamp'
export const ANALYTICS_TRIGGER_KEY = 'analytics_trigger'
export const MTM_ENTITIES_KEY = 'mtm'
export const TAB_HIDDEN_AT_KEY = 'ac_tab_was_hidden'
export const GOOGLE_ENTRY_OF_TAB_KEY = 'ac_google_entry_of_tab'
// Neutral names (not "fp"): these are an anti-abuse signal, not a user identifier.
export const BOT_CHALLENGE_V1_STORAGE_KEY = 'bot-challenge-v1'
export const BOT_CHALLENGE_SENT_KEY = 'bot-challenge-sent'
export const COOKIES_POLICY_KEY = 'cookies_policy'
